import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { SectionMenuView } from "@bpm/models";
import { environment } from "environments/environment";


@Injectable({ providedIn: "root" })
export class SectionMenuService {


  constructor(private _http: HttpClient) {}

  /**
   * Devuelve todos los procesos, secciones y fields del menu especificado
   * 
   */
  getView(menuId: number){
    return this._http.get<SectionMenuView[]>(`${environment.bpmApiUrl}/api/section-menu/${menuId}`);
  }
}
